import React, { useEffect, useState } from "react";
import "./Currency.scss";

import { IoSearch } from "react-icons/io5";
import { IoIosCheckmarkCircle } from "react-icons/io";

import Currencies from "../../../../constants/currencies";
import { useDispatch, useSelector } from "react-redux";
import { updateCurrency } from "../../../../redux/features/organization-slice";
import { changeOrganizationCurrency } from "../../../../api/organization";
import { toast } from "react-toastify";
import Loader from "../../../../components/Loader/Loader";
import useUserIsAllowed from "../../../../helpers/userAuthorized";
import { storage } from "../../../../helpers/storage";

const Currency = () => {
  const { currencyCode, id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );
  const dispatch = useDispatch();

  const [currencyList, setCurrencyList] = useState(Currencies);
  const [keyword, setKeyword] = useState("");

  const [loading, setLoading] = useState(false);

  const userIsAllowedToChangeCurrency = useUserIsAllowed("administrator");

  useEffect(() => {
    const regex = new RegExp(keyword, "i");

    const result = Currencies.filter(
      (currency) =>
        regex.test(currency.code) ||
        regex.test(currency.name) ||
        regex.test(currency.symbol)
    );

    setCurrencyList(result);
  }, [keyword]);

  const handleCurrencyChange = (item) => {
    if (userIsAllowedToChangeCurrency) {
      if (currencyCode !== item?.code) {
        setLoading(true);
        const currencyData = {
          currency: item?.code,
          currency_symbol: item?.symbol,
        };
        changeOrganizationCurrency(organization_id, currencyData)
          .then(async (res) => {
            let storageOrg = await storage.get("organization");
            storageOrg = storageOrg ? JSON.parse(storageOrg) : null;

            if (storageOrg) {
              storage.set(
                "organization",
                JSON.stringify({
                  ...storageOrg,
                  currency: item?.symbol,
                  currencyCode: item?.code,
                })
              );
            }
            dispatch(
              updateCurrency({
                currency: item?.symbol,
                currencyCode: item?.code,
              })
            );
            toast.dismiss(); toast.success("Currency updated.");
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss(); toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
              }
            } else {
              toast.dismiss(); toast.error("Error while changing currency.");
            }
          })
          .finally(() => {
            setLoading(false);
          });
      }
    } else {
      toast.dismiss(); toast.info(
        "You do not have sufficient permissions to perform this action. Please contact your administrator."
      );
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="currency-setting">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setKeyword(e.target.keyword.value);
          }}
          className="currency-search"
        >
          <div className="inputs">
            <input type="text" name="keyword" placeholder="Search currency." />
            <button type="submit">
              <IoSearch />
            </button>
          </div>
        </form>

        <div className="currency-list container-wrapper">
          {currencyList.map((el, i) => {
            const selected = el.code === currencyCode;
            return (
              <div
                className="item"
                onClick={() => {
                  handleCurrencyChange(el);
                }}
                key={i}
              >
                <div className="left">
                  <p className="flag">{el.icon}</p>
                  <div className="details">
                    <p>{el.code}</p>
                    <span>
                      {el.name} {`(${el.symbol})`}
                    </span>
                  </div>
                </div>
                {selected && <IoIosCheckmarkCircle />}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Currency;
